import {
  Component
} from '@angular/core';


export class SkyActionButtonHeaderComponent {
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-action-button-header',
  styles: [`.sky-action-button-header {
  display: inline-block;
  font-family: "Blackbaud Sans Condensed", "Helvetica Neue Condensed", "Arial Narrow";
  color: #282b31;
  font-weight: 300;
  font-size: 26px;
}

@media (max-width: 767px) {
  .sky-action-button-header {
    margin-left: 5px;
    margin-right: 5px;
  }
}

@media (min-width: 768px) {
  .sky-action-button-header {
    display: block;
    margin-bottom: 20px;
  }
}
`],
  template: `<div class="sky-action-button-header">
  <ng-content></ng-content>
</div>
`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
